module.exports = __webpack_public_path__ + "img/desktop.59f27356.svg";